import Enum from '/@/modules/core/app/helpers/Enum';

export class EstateSettingType extends Enum {
  static APPRAISAL_AND_INVENTORY_FORMS_SENT_TO_PROBATE_REFEREE =
    'appraisal_and_inventory_forms_sent_to_probate_referee';

  static BOOKED_MEETING_WITH_NOTARY = 'booked_meeting_with_notary';

  static BOOKED_WILL_NOTARIZATION_MEETING = 'booked_will_notarization_meeting';

  static BOOKED_PROTECTION_MANDATE_NOTARIZATION_MEETING =
    'booked_protection_mandate_notarization_meeting';

  static BOOKED_WILL_REVIEW_MEETING = 'booked_will_review_meeting';

  static BOOKED_EXECUTOR_KICKOFF_MEETING = 'booked_executor_kickoff_meeting';

  static DECEASED_APPLIED_OR_RECEIVED_CPP = 'deceased_applied_or_received_cpp';

  static DECEASED_APPLIED_OR_RECEIVED_QPP = 'deceased_applied_or_received_qpp';

  static DECEASED_APPLIED_OR_RECEIVED_OAS = 'deceased_applied_or_received_oas';

  static DECEASED_WAS_ELIGIBLE_FOR_FAMILY_ALLOWANCES_OR_CHILD_TAX_BENEFIT =
    'deceased_was_eligible_for_family_allowances_or_child_tax_benefit';

  static DECEASED_LIVED_OR_WORKED_OUTSIDE_CANADA = 'deceased_lived_or_worked_outside_canada';

  static IS_INVENTORY_MARKED_AS_UP_TO_DATE = 'is_inventory_marked_as_up_to_date';

  static PLANNER_HAS_BUSINESS_INTEREST = 'planner_has_business_interest';

  static SPOUSE_WAS_ELIGIBLE_FOR_FAMILY_ALLOWANCES_OR_CHILD_TAX_BENEFIT =
    'spouse_was_eligible_for_family_allowances_or_child_tax_benefit';

  static DECEASED_EVER_ENGAGED_WORK_OUTSIDE_USA = 'deceased_ever_engaged_work_outside_usa';

  static HAS_PROPERTY_OUTSIDE_CALIFORNIA = 'has_property_outside_california';

  static HAS_WILL_INPUT_STAGES_LOCKED = 'has_will_input_stages_locked';

  static HAS_ESTATE_DISTRIBUTION_FRAMEWORK_V1 = 'has_estate_distribution_framework_v1';
}
